import ActivitiesCreateEditForm from './ActivitiesCreateEditForm';

export default ActivitiesCreateEditForm;
